<!--
    @不参与审核的领导首页-项目待办任务-项目
-->
<template>
	<div class="leader_taskdeal">
		<div class="item">
			<p class="task_title">
				<span :title="data.roleName">{{data.roleName}}</span>
				<span class="task_icon el-icon-warning-outline"></span>
			</p>
			<div class="task_msg">
				<div class="task_num">{{data.sumAuditTask}}</div>
				<div class="task_data">
					<p class="task_ing">进行中&nbsp;&nbsp;&nbsp;&nbsp;{{data.auditTaskProcess}}</p>
					<p class="task_down">已完成&nbsp;&nbsp;&nbsp;&nbsp;{{data.auditTaskActive}}</p>
				</div>
			</div>
			<div class="task_progress">
				<el-progress :percentage="toRound(data.auditTaskPercentage)"></el-progress>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props:{
		data:{
			type:Object,
			default:function(){
				return {};
			}
		}
	},
	data(){
		return{}
	},
	methods:{
		toRound(value){
			return Math.floor(value*100)/100*100;
		}
	}
}
</script>

<style lang="less" scoped>
.leader_taskdeal{
	.item{
		.task_title{
			position: relative;
			color: #979797;
			&>span:nth-child(1){
				display: inline-block;
				width: calc(100% - 16px);
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.task_icon{
				position: absolute;
				right: 0;
				top: 0;
			}
		}
		.task_msg{
			margin: 15px 0;
			display: flex;
			justify-content: space-between;
			>div{
				// width: 50%;
				&.task_num{
					font-size: 28px;
				}
				&.task_data{
					p{
						position: relative;
						padding-left: 10px;
					}
					.task_ing:before{
						content: '';
						width: 6px;
						height: 6px;
						border-radius: 50%;
						position: absolute;
						top: 50%;
						left: 0;
						transform: translate(0,-50%);
						background: #1890FF;
					}
					.task_down:before{
						content: '';
						width: 6px;
						height: 6px;
						border-radius: 50%;
						position: absolute;
						top: 50%;
						left: 0;
						transform: translate(0,-50%);
						background: #6AA427;
					}
				}
			}
		}
		.task_progress{
			/deep/ .el-progress-bar{
				width: 95%;
				.el-progress-bar__inner{
					background-color: #1890FF;
				}
			}
		}
	}
}
</style>
